import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["brand", "categoryId", "pageSize", "sellerId", "subCategoryId", "sortOrientation", "sortType"];
import React from 'react';
import { bool, string, number, shape } from 'prop-types';
import { useProductListBySeller } from '@magalu/mixer-graphql';
import ProductList from '../ProductList/ProductList';
var ProductListSeller = function ProductListSeller(_ref) {
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static$brand = _ref$static.brand,
    brand = _ref$static$brand === void 0 ? '' : _ref$static$brand,
    _ref$static$categoryI = _ref$static.categoryId,
    categoryId = _ref$static$categoryI === void 0 ? '' : _ref$static$categoryI,
    _ref$static$pageSize = _ref$static.pageSize,
    pageSize = _ref$static$pageSize === void 0 ? 10 : _ref$static$pageSize,
    sellerId = _ref$static.sellerId,
    _ref$static$subCatego = _ref$static.subCategoryId,
    subCategoryId = _ref$static$subCatego === void 0 ? '' : _ref$static$subCatego,
    _ref$static$sortOrien = _ref$static.sortOrientation,
    sortOrientation = _ref$static$sortOrien === void 0 ? '' : _ref$static$sortOrien,
    sortType = _ref$static.sortType,
    staticProps = _objectWithoutProperties(_ref$static, _excluded),
    structure = _ref.structure;
  var _useProductListBySell = useProductListBySeller({
      brand: brand,
      categoryId: categoryId,
      pageSize: pageSize,
      sellerId: sellerId,
      sortOrientation: sortOrientation,
      sortType: sortType,
      subCategoryId: subCategoryId
    }),
    productList = _useProductListBySell.productList;
  return productList.length ? React.createElement(ProductList, {
    data: _extends({}, data, {
      search: {
        products: productList
      }
    }),
    "static": _extends({}, staticProps),
    structure: structure
  }) : null;
};
process.env.NODE_ENV !== "production" ? ProductListSeller.propTypes = {
  data: shape({}),
  "static": shape({
    allowEmptyRating: bool,
    brand: string,
    categoryId: string,
    context: shape({}),
    display: string,
    domain: string,
    gridGap: number,
    inCashDescription: string,
    isSellerPage: bool,
    isSlider: bool,
    limit: number,
    origin: string,
    pageSize: number,
    position: number,
    sellerId: string,
    showDiscount: bool,
    showDiscountOnlyCashInfo: bool,
    showInCashLabel: bool,
    showWishBtn: bool,
    sortOrientation: string,
    sortType: string,
    spa: bool,
    subCategoryId: string,
    type: string
  }),
  structure: shape({})
} : void 0;
ProductListSeller.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
export default ProductListSeller;